import type { RouteLocationNormalized } from 'vue-router';
import type { Guard, GuardReturn } from './interfaces';

export async function runGuards(to: RouteLocationNormalized, from: RouteLocationNormalized): Promise<GuardReturn> {
  const guards: Guard[] = [];

  // Get all guards set for current and parent routes
  to.matched.forEach(({ meta }) => {
    if (!meta.guards) {
      return;
    }

    if (Array.isArray(meta.guards)) {
      guards.push(...meta.guards.filter((item) => typeof item === 'function' && !guards.includes(item)));
    }
  });

  // Run every guard until cancel, redirect or error
  for (const guard of guards) {
    const result = await guard(to, from);

    if (typeof result !== 'undefined' && result !== true) {
      return result;
    }
  }

  return undefined;
}
